import { Injectable } from '@angular/core';
import { NGXLogger, NgxLoggerLevel } from 'ngx-logger';
import { environment } from 'src/environments/environment';
import { HttpHeaders } from '@angular/common/http';
import { LoggingInfo } from '../models/logging-info.model';
import moment from 'moment';
import { LoggingMessageService } from './logging-message.service';
import { StorageService } from './storage.service';


export interface ILoggingApiService {
  debug(appFileName: string, appMethod: string, type: 'Request' | 'Response', method: 'GET' | 'POST', subscription: string, availableSubscriptions: string,  start: number, path: string, queryString: string, statusCode: number, end: number);
  info(appFileName: string, appMethod: string, type: 'Request' | 'Response', method: 'GET' | 'POST', subscriptionsubscription: string, availableSubscriptions: string, start: number, path: string, queryString: string, statusCode: number, end: number);
  warning(appFileName: string, appMethod: string, type: 'Request' | 'Response', method: 'GET' | 'POST', subscription: string, availableSubscriptions: string, start: number, path: string, queryString: string, statusCode: number, end: number);
  error(appFileName: string, appMethod: string, type: 'Request' | 'Response', method: 'GET' | 'POST', subscription: string, availableSubscriptions: string, start: number, path: string, queryString: string, statusCode: number, end: number);
}

@Injectable({
  providedIn: 'root'
})
export class LoggingApiService implements ILoggingApiService {

  constructor(private logger: LoggingMessageService, public storageService: StorageService) { }

  public debug(appFileName: string, appMethod: string, type: 'Request' | 'Response', method: 'GET' | 'POST', subscription: string, availableSubscriptions: string, start: number, path: string, queryString: string, statusCode?: number, end?: number) {
    if (environment.LogLevel === NgxLoggerLevel.DEBUG) {
      const message = this.formatApiMessage(type, method, start, path, queryString, statusCode, end);
      this.logger.debug(appFileName, appMethod, +subscription, availableSubscriptions,  message, '');
    }
  }

  public info(appFileName: string, appMethod: string, type: 'Request' | 'Response', method: 'GET' | 'POST', subscription: string, availableSubscriptions: string, start: number, path: string, queryString: string, statusCode?: number, end?: number) {
    if ((environment.LogLevel === NgxLoggerLevel.DEBUG) || (environment.LogLevel === NgxLoggerLevel.INFO)) {
      const message = this.formatApiMessage(type, method, start, path, queryString, statusCode, end);
      this.logger.info(appFileName,  appMethod, +subscription, availableSubscriptions,  message, '');
    }
  }

  public warning(appFileName: string, appMethod: string, type: 'Request' | 'Response', method: 'GET' | 'POST', subscription: string, availableSubscriptions: string, start: number, path: string, queryString: string, statusCode?: number, end?: number) {
    if ((environment.LogLevel === NgxLoggerLevel.DEBUG) || (environment.LogLevel === NgxLoggerLevel.INFO) || (environment.LogLevel === NgxLoggerLevel.WARN)) {
      const message = this.formatApiMessage(type, method, start, path, queryString, statusCode, end);
      this.logger.warn(appFileName, appMethod, +subscription, availableSubscriptions, message, '');
    }
  }

  public error(appFileName: string, appMethod: string, type: 'Request' | 'Response', method: 'GET' | 'POST', subscription: string, availableSubscriptions: string, start: number, path: string, queryString: string, statusCode?: number, end?: number) {
    if ((environment.LogLevel === NgxLoggerLevel.DEBUG) || (environment.LogLevel === NgxLoggerLevel.INFO) || (environment.LogLevel === NgxLoggerLevel.WARN) || (environment.LogLevel === NgxLoggerLevel.ERROR)) {
      const message = this.formatApiMessage(type, method, start, path, queryString, statusCode, end);
      this.logger.error(appFileName, appMethod, +subscription, availableSubscriptions, message, '');
    }
  }

  private formatApiMessage(type: 'Request' | 'Response', method: 'GET' | 'POST', start: number, path: string, queryString: string, statusCode?: number, end?: number): string {
    const env = environment.production ? 'PROD' : 'DEV';
    const startTime = this.getFormattedDate(start);
    const code = (statusCode === null) ? '' : statusCode;

    let elapsedTime = '';
    let endTime = '';
    if ((end !== null) && (end !== 0)) {
      endTime = this.getFormattedDate(end);
      elapsedTime = this.getElapsedTime(start, end);
    }

    const msg = `Type:${type}, Start:${startTime}, Method:${method}, Path:${path}, Params:${queryString}, End:${endTime}, Status:${code}, Elapsed:${elapsedTime}`;
    return msg;
  }

  private getFormattedDate(numericDate: number): string {
    const nowLocal = moment(numericDate).local();
    const now = nowLocal.format('YYYY-MM-DD HH:mm:ss:SSSS');
    return now;
  }

  private getElapsedTime(start: number, end: number): string {
    const elapsed = end - start;
    return `${elapsed}/ms`;
  }
}
